import axios from 'axios';
import { Map } from 'immutable';
import React, { useEffect, useState } from 'react';
import { useReframe } from 'nike-re-framejs';

import { Button } from 'nike-ui/src/components/button/Button';
import i18n from '@i18n';
import { getUrl } from '@/common/oldMobile';
import PopupNg from '@/ui/PopupNg';
import { catcher } from '@/_http/utils';
import Selectbox from '@/common/components/nikeforms/Selectbox';
import { handleValidForm, makeForm, validator } from 'nike-form-js';
import { empty, PATTERN_EMAIL } from '@/common/validations';
import Input from '@/common/components/nikeforms/Input';
import ReadOnly from '@/common/components/nikeforms/Readonly';
import { accountActionAllowed$ } from '@/account/subs';
import { isProfileContactTopicEnabled } from 'nike-ui/src/profiles';

const validators = [
    [
        ['email'],
        strValue => {
            return PATTERN_EMAIL.test(strValue) ? null : i18n('error.validacia.formular.registracia.email');
        }
    ],
    [
        ['reasonType'],
        // FIXME - mobil ako jediny ma required reason?
        value => (!categoriesAvailable || (value && value !== '-1') ? null : empty('error.validacia.required')(value))
    ],
    [['reasonText'], empty('error.validacia.required')]
];

function useForm(email, hash) {
    const [form] = useState(() => {
        const initData = Map({ email });
        return makeForm(initData, {
            validator: validator(validators, errors => errors)
        });
    });
    const [isLoading, setIsLoading] = useState(false);
    const submitForm = handleValidForm(form, formValues => {
        const values = formValues.toJS();
        const data = {
            hash,
            typReklamacie: values.reasonType,
            textReklamacie: values.reasonText,
            email: values.email
        };
        setIsLoading(true);
        axios
            .post(getUrl('REKLAMACIA_SUBMIT'), data)
            .then(() => {
                PopupNg.dispatcher.show({
                    messages: 'tiket.detailTiketu.reklamacia.success.server',
                    close: ['history_back']
                });
            })
            .catch(catcher.handleMasterError)
            .finally(() => {
                setIsLoading(false);
            });
    });
    return [form, submitForm, isLoading];
}

function ReklamaciaForm({ initialData }) {
    const [form, submitForm, isLoading] = useForm(initialData.get('userEmail'), initialData.get('hash'));

    const contactTopicProfile = isProfileContactTopicEnabled();
    const [categories, setCategories] = useState();
    useEffect(() => {
        if (contactTopicProfile) {
            axios
                .get('/api/contact-us/categories')
                .then(categories => {
                    setCategories(categories);
                    categoriesAvailable = categories && categories.length > 0;
                })
                .catch(() => {
                    setCategories([]);
                    categoriesAvailable = false;
                });
        }
    }, [contactTopicProfile]);
    const typyReklamacie = contactTopicProfile
        ? categories
              ?.find(t => t.name === 'Tikety')
              ?.categories?.filter(c => c.name !== 'Vyber kategóriu')
              ?.map(c => [c.id, c.name]) || []
        : i18n('tiket.detailTiketu.reklamacia.option.typ.others')
              .split(';')
              .map(choice => [choice, choice]);

    const { subscribe } = useReframe();
    const showContractId = subscribe(accountActionAllowed$('SHOW_CONTRACT_ID'));

    return (
        <div className="page-wrap">
            <form className="nike-form" onSubmit={submitForm}>
                <Input form={form} path={['email']} label={i18n('tiket.detailTiketu.reklamacia.label.email')} />
                {showContractId ? (
                    <ReadOnly
                        form={form}
                        path={['userId']}
                        label={i18n('tiket.detailTiketu.reklamacia.label.cisloKlienta')}
                        defaultValue={initialData.get('userId')}
                    />
                ) : null}
                <ReadOnly
                    form={form}
                    path={['hash']}
                    label={i18n('tiket.detailTiketu.reklamacia.label.cisloTiketu')}
                    defaultValue={initialData.get('ticketNumber')}
                />
                {typyReklamacie?.length ? (
                    <Selectbox
                        form={form}
                        path={['reasonType']}
                        label={i18n('tiket.detailTiketu.reklamacia.label.typ')}
                        emptyLabel={i18n('tiket.detailTiketu.reklamacia.option.typ.default')}
                        mandatory={true}
                        options={typyReklamacie}
                    />
                ) : null}
                <Input
                    type="textarea"
                    rows={3}
                    form={form}
                    path={['reasonText']}
                    label={i18n('tiket.detailTiketu.reklamacia.label.komentar')}
                    placeholder={i18n('tiket.detailTiketu.reklamacia.option.text.default')}
                />
                <label className="nike-input">
                    <Button
                        disabled={isLoading}
                        primary
                        type="submit"
                        label={i18n('tiket.detailTiketu.reklamacia.label.odoslat')}
                    />
                </label>
            </form>
        </div>
    );
}

let categoriesAvailable = false;

export default ReklamaciaForm;
